import styled from "styled-components";

export const FieldGroup = styled.div`
  margin-bottom: 20px;
`;
